import { FC, ReactNode, useCallback, useEffect } from 'react'
import { Header } from '../Header'
import styles from './styles.module.css'
import { RefcodeProvider } from '../../providers/refcode'
import { Toaster } from 'react-hot-toast'
import { useAuthContext } from '../../providers/auth'
import { getMyInfo } from '../../services/profileService'
import { useModalContext } from '../../providers/modal'
import { EditProfile } from '../../containers/EditProfile'

interface LayoutProps {
  children: ReactNode
}

export const Layout: FC<LayoutProps> = (props: LayoutProps) => {
  const { children } = props
  const { authorized, accessToken } = useAuthContext()
  const { setContent, setIsModalOpen } = useModalContext()

  const createUpdateProfile = useCallback(() => {
    setContent(
      <EditProfile
        onClose={() => {
          setIsModalOpen(false)
          setContent(null)
        }}
      />
    )
    setIsModalOpen(true)
  }, [setContent, setIsModalOpen])

  useEffect(() => {
    if (authorized && accessToken) {
      getMyInfo(accessToken).then((data) => {
        if (!data.nickname) {
          createUpdateProfile()
        }
      })
    }
  }, [authorized, accessToken, createUpdateProfile])

  return (
    <RefcodeProvider>
      <div className={styles.container}>
        <Header />
        <main className={styles.main}>{children}</main>
      </div>
      <Toaster
        position="bottom-right"
        toastOptions={{
          icon: null,
          style: {
            backgroundColor: '#252424',
            color: 'white',
            borderRadius: 15,
            borderWidth: 0,
            padding: 0,
            borderStyle: 'solid',
            fontSize: '15px',
            lineHeight: '19.5px',
            fontFamily: 'Pangram',
            fontWeight: 500,
            maxWidth: 'unset'
          },
          error: {
            style: {
              borderColor: 'var(--accent-red)',
              borderWidth: 1,
              overflow: 'hidden',
              padding: '10px 16px',
              backgroundColor: 'var(--accent-red)'
            }
          }
        }}
      />
    </RefcodeProvider>
  )
}
